module.exports = __webpack_public_path__ + "assets/Logo.5a02ec8d.svg";